export default "__VITE_ASSET__Bsd7a0Hx__"